import { useQuery } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import { getPrivateInstance } from "../_privateInstance";
import { DEFAULT_TOP_RANKING_LIMIT } from "../../utils/kpiRankingMetric";
import {
  parseSportsbookTopLeaguesResponse,
  type SportsbookRankingRow,
  type SportsbookTopLeaguesData,
} from "./normalizeSportsbookRankingRows";

export type SportsbookTopLeaguesFilters = {
  start_date: string;
  end_date: string;
  /** Number of ranked rows to return (BE: 1–50). Defaults to 10. */
  limit?: number;
};

export type SportsbookTopLeagueRow = SportsbookRankingRow;

export const fetchSportsbookTopLeagues = async (
  filters: SportsbookTopLeaguesFilters,
): Promise<SportsbookTopLeaguesData> => {
  const instance = getPrivateInstance();
  const { start_date, end_date, limit = DEFAULT_TOP_RANKING_LIMIT } = filters;
  const response = await instance.get(API_ROUTES.SPORTSBOOK_TOP_LEAGUES, {
    params: { start_date, end_date, limit },
  });
  return parseSportsbookTopLeaguesResponse(response?.data);
};

export const useGetSportsbookTopLeagues = (
  filters: SportsbookTopLeaguesFilters,
) => {
  const {
    start_date,
    end_date,
    limit = DEFAULT_TOP_RANKING_LIMIT,
  } = filters;

  return useQuery<SportsbookTopLeaguesData, Error>({
    queryKey: ["SPORTSBOOK_TOP_LEAGUES", start_date, end_date, limit],
    queryFn: () => fetchSportsbookTopLeagues(filters),
    enabled: Boolean(start_date && end_date),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
